import React from 'react';

import { QBox, QTabs } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { routes } from 'utils';

const ViewWithNavigation: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const TABS = [
    { id: routes.supplierList, title: t('navigation.tabs.supplier') },
    { id: routes.policy.root, title: t('navigation.tabs.policy') },
  ];

  const activeRouteId = (): string => {
    switch (true) {
      case pathname.includes('/supplier-policy'):
        return TABS[1].id;
      default:
        return TABS[0].id;
    }
  };

  return (
    <>
      <QTabs tabs={TABS} onClick={(tabItem) => navigate(tabItem.id)} activeTabId={activeRouteId()} />
      <QBox pt={3}>
        <Outlet />
      </QBox>
    </>
  );
};

export default ViewWithNavigation;
